/**
 * HEADER — Rediseño B2B SaaS Profesional
 * 
 * - Sticky con shadow sutil
 * - Nav links con underline hover
 * - Logo completo en mobile
 * - Sin backgrounds decorativos
 */

import React, { useState, useEffect } from 'react';
import { Calendar, Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const scrollToForm = () => {
    scrollToSection('formulario-contacto');
  };

  const navLinks = [
    { label: 'Problema', id: 'problema' },
    { label: 'Solución', id: 'solucion' },
    { label: 'Cómo Funciona', id: 'como-funciona' },
    { label: 'FAQ', id: 'faq' }
  ];

  return (
    <header
      className={`
        fixed top-0 left-0 right-0 z-50 bg-white transition-all duration-300
        ${isScrolled ? 'shadow-md' : ''}
      `}
    >
      <div className="max-w-[1120px] mx-auto px-6">
        <div className="flex items-center justify-between py-4 gap-8">
          
          {/* Logo */}
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="flex items-center gap-3 group"
          >
            <div className="shrink-0">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="16" height="16" fill="#0b63c6"/>
                <rect y="24" width="24" height="8" fill="#0b63c6"/>
                <rect y="16" width="8" height="8" fill="#0b63c6"/>
                <rect x="16" width="16" height="8" fill="#0b63c6"/>
                <rect x="24" y="8" width="8" height="16" fill="#0b63c6"/>
                <path d="M32 24L24 32V24H32Z" fill="#0b63c6"/>
              </svg>
            </div>
            <div className="flex flex-col leading-tight">
              <span className="text-[17px] font-bold text-[#0b1220] group-hover:text-[#0b63c6] transition-colors">
                Dashwise
              </span>
              <span className="text-[11px] font-medium text-[#6b7280]">
                Transporte Perú
              </span>
            </div>
          </button>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className="px-4 py-2 text-[14px] font-semibold text-[#6b7280] hover:text-[#0b63c6] transition-colors relative group"
              >
                {link.label}
                <span className="absolute bottom-1 left-4 right-4 h-0.5 bg-[#0b63c6] scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
              </button>
            ))}
          </nav>

          {/* Desktop CTA */}
          <button
            onClick={scrollToForm}
            className="hidden md:flex items-center gap-2 bg-[#0b63c6] hover:bg-[#0957b0] text-white text-[14px] font-semibold px-5 py-2.5 rounded-lg transition-colors duration-200 shrink-0"
          >
            <Calendar size={16} strokeWidth={2} />
            Agendar Diagnóstico
          </button>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-[#0b1220]"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={`
            md:hidden overflow-hidden transition-all duration-300
            ${mobileMenuOpen ? 'max-h-[400px] pb-4' : 'max-h-0'}
          `}
        >
          <nav className="flex flex-col gap-1 mb-4 pt-2 border-t border-black/[0.06]">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className="px-4 py-2.5 text-[15px] font-semibold text-[#6b7280] hover:text-[#0b63c6] hover:bg-blue-50 rounded-lg text-left transition-colors"
              >
                {link.label}
              </button>
            ))}
          </nav>
          <button
            onClick={scrollToForm}
            className="w-full flex items-center justify-center gap-2 bg-[#0b63c6] hover:bg-[#0957b0] text-white text-[14px] font-semibold px-5 py-3 rounded-lg transition-colors"
          >
            <Calendar size={16} strokeWidth={2} />
            Agendar Diagnóstico
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;